import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAccountId, getDeviceIdFromSession, getPersonIdFromToken, getSelectedAccountInfo } from '@ibk/shared-auth';
import { attemptTokenRefresh, createApiErrorSimple, createAuthHeaders, extractUrl, getTimeout, shouldAttemptRefresh, } from '../api/authUtils';
import { config } from '../config';
import { ENABLED_FEATURE_HEADER, getEnabledFeature } from '../developerSettings';
import { selectAccessToken } from '../store/selectors/tokensSelectors';
const API_BASE_URL = config.apiIbkLegacyBffUrl;
const DEFAULT_TIMEOUT = 30000;
const setAuthorizationHeader = (headers, state) => {
    const authHeaders = createAuthHeaders(state);
    if (authHeaders.Authorization) {
        headers.set('Authorization', authHeaders.Authorization);
    }
};
const setIbkLegacyBffHeaders = (headers, state) => {
    headers.set('Content-Type', 'application/json');
    headers.set('Accept', 'application/json, text/plain, */*');
    const accountId = getAccountId() ?? getSelectedAccountInfo()?.accountId;
    if (accountId) {
        headers.set('account-id', accountId);
    }
    const accessToken = selectAccessToken(state);
    if (accessToken) {
        const personId = getPersonIdFromToken(accessToken);
        if (personId) {
            headers.set('person-id', personId);
        }
    }
    const deviceId = getDeviceIdFromSession();
    if (deviceId) {
        headers.set('device-id', deviceId);
    }
};
const createIbkLegacyBffBaseQuery = (baseUrl, timeout) => {
    return fetchBaseQuery({
        baseUrl,
        timeout,
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            setAuthorizationHeader(headers, state);
            setIbkLegacyBffHeaders(headers, state);
            const enabledFeature = getEnabledFeature();
            if (enabledFeature) {
                headers.set(ENABLED_FEATURE_HEADER, enabledFeature);
            }
            return headers;
        },
    });
};
export const customIbkLegacyBffBaseQuery = async (args, api, extraOptions) => {
    const url = extractUrl(args);
    const timeout = getTimeout(args, DEFAULT_TIMEOUT);
    const baseQuery = createIbkLegacyBffBaseQuery(API_BASE_URL, timeout);
    const queryArgs = typeof args === 'string' ? url : { ...args, url };
    const result = await baseQuery(queryArgs, api, extraOptions);
    if (result.error) {
        const fetchError = result.error;
        if (shouldAttemptRefresh(fetchError)) {
            const refreshSuccess = await attemptTokenRefresh(api);
            if (refreshSuccess) {
                const refreshedBaseQuery = createIbkLegacyBffBaseQuery(API_BASE_URL, timeout);
                return refreshedBaseQuery(queryArgs, api, extraOptions);
            }
        }
        if ('status' in fetchError) {
            return { error: createApiErrorSimple(fetchError) };
        }
    }
    return result;
};
export const ibkLegacyBffApi = createApi({
    reducerPath: 'ibkLegacyBffApi',
    baseQuery: customIbkLegacyBffBaseQuery,
    tagTypes: ['slip'],
    endpoints: () => ({}),
});
